module.exports = __webpack_public_path__ + "img/halloween-purple.4ae66dca.svg";